// 定义项目内的表名
const featuresFeaturesItemList = "features/item-list";
const featuresFeaturesItemListAll = "features2/item-list-all";
const featuresFeaturesItemListOpened = "features2/item-list-opened";
const featuresFeaturesItemListClosed = "features2/item-list-closed";

const tableList = {
  featuresFeaturesItemList,
  featuresFeaturesItemListAll,
  featuresFeaturesItemListOpened,
  featuresFeaturesItemListClosed
};

export default tableList;
